import { IFormSection, TSubmitType } from "../../types/common";
import { API_INVENTORY } from "../../utils/apis";
import { CATEGORY_INVENTORY_TYPE, VEHICLE_TYPE } from "../../utils/constants";
import { useGetConfigurableOptions } from "../../utils/formUtils";

import { URL_INVENTORY } from "../../utils/urls";

export type TFormCustomProps = {
  id?: number;
  submitType?: TSubmitType;
};

export const useInventoryForm = ({ form }) => {
  const sections: IFormSection[] = [
    {
      title: "Inventory Information",
      fields: [
        {
          field_name: "name",
          type: "text",
          label: "Name",
          props: { required: true },
        },
        {
          field_name: "type_of_stock",
          type: "select",
          label: "Type of Stock",
          options_data: [
            { name: "Old Stock", id: "old_stock" },
            { name: "New Stock", id: "new_stock" },
          ],
        },
        {
          field_name: "vehicle_type",
          type: "select",
          label: "vehicle Type",
          props: { required: true },
          options_name: "vehicle_types",
        },
        {
          field_name: "category",
          type: "select",
          label: "Category",
          options_name: "categories",
        },
        {
          field_name: "model",
          type: "text",
          label: "Model",
        },
        {
          field_name: "description",
          type: "textarea",
          label: "Description",
          props: { required: true },
        },
        {
          field_name: "quantity",
          type: "number",
          label: "Quantity",
          visible: form?.id !== undefined,
        },
        {
          field_name: "specifications",
          type: "textarea",
          label: "Specifications",
        },
      ],
    },
  ];

  const redirect = `${URL_INVENTORY}`;

  const getConfigOptions = () => {
    const configList = [
      { name: "vehicle_types", key: VEHICLE_TYPE },
      { name: "categories", key: CATEGORY_INVENTORY_TYPE },
    ];
    return useGetConfigurableOptions(configList);
  };
  const options = {
    ...getConfigOptions(),
  };

  return { sections, redirect, options };
};

export function submitInventory(payload: any, id: number | null) {
  //  on update
  if (id) {
    return {
      id,
      api: API_INVENTORY,
      params: payload,
    };
  }
  // on create
  return {
    api: API_INVENTORY,
    params: payload,
  };
}
